import React, { useState } from 'react';
import '../styles/Contact.css';

function Contact({ language }) {
  const [status, setStatus] = useState({
    submitting: false,
    succeeded: false,
    error: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, succeeded: false, error: false });

    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://formspree.io/f/mwpaagql', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        setStatus({ submitting: false, succeeded: true, error: false });
        form.reset();
        // Reset success message after 5 seconds
        setTimeout(() => {
          setStatus({ submitting: false, succeeded: false, error: false });
        }, 5000);
      } else {
        setStatus({ submitting: false, succeeded: false, error: true });
      }
    } catch (error) {
      setStatus({ submitting: false, succeeded: false, error: true });
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <h2 className="contact-title">
          <span lang="en">Contact Us</span>
          <span lang="fr">Contactez-nous</span>
        </h2>

        <p className="contact-subtitle">
          <span lang="en">Let's start your digital transformation journey together</span>
          <span lang="fr">Commençons ensemble votre parcours de transformation digitale</span>
        </p>

        <div className="contact-container">
          {/* Contact Information */}
          <div className="contact-info">
            <div className="info-item">
              <div className="info-icon email-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div className="info-content">
                <h3>Email</h3>
                <a href="mailto:Contact@nexofortis.com">Contact@nexofortis.com</a>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon phone-icon">
                <i className="fas fa-phone"></i>
              </div>
              <div className="info-content">
                <h3>Phone</h3>
                <a href="tel:+21621455247">+216 21 455 247</a>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon address-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div className="info-content">
                <h3>Address</h3>
                <p>Tunis, Tunisia</p>
              </div>
            </div>

            <div className="contact-info-social">
              <a href="https://www.linkedin.com/company/nexofortis-services-informatiques/" 
              className="linkedin-link contact-linkedin-btn" 
              target="_blank" 
              rel="noopener noreferrer" 
              aria-label="LinkedIn">
               <i className="fab fa-linkedin"></i> LinkedIn
              </a>
            </div>
             

          </div>

          

          {/* Contact Form with Formspree */}
          <div className="contact-form-wrapper">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">
                  <span lang="en">Name</span>
                  <span lang="fr">Nom</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder={language === 'en' ? 'Your full name' : 'Votre nom complet'}
                  required
                  disabled={status.submitting}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="your@email.com"
                  required
                  disabled={status.submitting}
                />
              </div>

              <div className="form-group">
                <label htmlFor="company">
                  <span lang="en">Company</span>
                  <span lang="fr">Entreprise</span>
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  placeholder={language === 'en' ? 'Your company name' : 'Nom de votre entreprise'}
                  disabled={status.submitting}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder={language === 'en' ? 'Describe your project...' : 'Décrivez votre projet...'}
                  required
                  rows="5"
                  disabled={status.submitting}
                />
              </div>

              {/* Success Message */}
              {status.succeeded && (
                <div className="success-message">
                  <i className="fas fa-check-circle"></i>
                  <span lang="en">Thank you! Your message has been sent successfully.</span>
                  <span lang="fr">Merci ! Votre message a été envoyé avec succès.</span>
                </div>
              )}

              {/* Error Message */}
              {status.error && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>
                  <span lang="en">Oops! There was a problem sending your message.</span>
                  <span lang="fr">Oups ! Une erreur s'est produite lors de l'envoi.</span>
                </div>
              )}

              <button 
                type="submit" 
                className="submit-btn"
                disabled={status.submitting}
              >
                {status.submitting ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    <span lang="en">Sending...</span>
                    <span lang="fr">Envoi en cours...</span>
                  </>
                ) : (
                  <>
                    <span lang="en">Send Message</span>
                    <span lang="fr">Envoyer le message</span>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
